// extracted by mini-css-extract-plugin
module.exports = {"containerWrapper":"styles_containerWrapper__10_ed","errorWrapper":"styles_errorWrapper__NrsR5","logoWrapper":"styles_logoWrapper__-hdQN"};